module.exports = [
	{
		"selector": "//ArrayExpression",
		"version": "3",
		"en": {
			"name": "ArrayExpression"
		}
	},
	{
		"selector": "//ArrayPattern",
		"version": "2015",
		"en": {
			"name": "ArrayPattern"
		}
	},
	{
		"selector": "//ArrowFunctionExpression",
		"version": "2015",
		"en": {
			"name": "ArrowFunctionExpression"
		}
	},
	{
		"selector": "//AssignmentExpression[@operator=='**']",
		"version": "2016",
		"en": {
			"name": "AssignmentExpression exponentiation operator"
		}
	},
	{
		"selector": "//AssignmentExpression",
		"version": "3",
		"en": {
			"name": "AssignmentExpression"
		}
	},
	{
		"selector": "//AssignmentPattern",
		"version": "2015",
		"en": {
			"name": "AssignmentPattern"
		}
	},
	{
		"selector": "//AwaitExpression",
		"version": "proposal",
		"en": {
			"name": "AwaitExpression"
		}
	},
	{
		"selector": "//BinaryExpression[@operator=='**']",
		"version": "2016",
		"en": {
			"name": "BinaryExpression exponentiation operator"
		}
	},
	{
		"selector": "//BinaryExpression",
		"version": "3",
		"en": {
			"name": "BinaryExpression"
		}
	},
	{
		"selector": "//BindExpression",
		"version": "proposal",
		"en": {
			"name": "BindExpression"
		}
	},
	{
		"selector": "//BlockStatement",
		"trivial": true,
		"version": "3",
		"en": {
			"name": "BlockStatement"
		}
	},
	{
		"selector": "//BooleanLiteral",
		"version": "3",
		"en": {
			"name": "BooleanLiteral"
		}
	},
	{
		"selector": "//BreakStatement",
		"version": "3",
		"en": {
			"name": "BreakStatement"
		}
	},
	{
		"selector": "//CallExpression",
		"version": "3",
		"en": {
			"name": "CallExpression"
		}
	},
	{
		"selector": "//CatchClause",
		"version": "3",
		"en": {
			"name": "CatchClause"
		}
	},
	{
		"selector": "//ClassBody",
		"version": "2015",
		"en": {
			"name": "ClassBody"
		}
	},
	{
		"selector": "//ClassDeclaration",
		"version": "2015",
		"en": {
			"name": "ClassDeclaration"
		}
	},
	{
		"selector": "//ClassExpression",
		"version": "2015",
		"en": {
			"name": "ClassExpression"
		}
	},
	{
		"selector": "//ClassMethod[@kind=='constructor']",
		"version": "2015",
		"en": {
			"name": "ClassMethod-constructor"
		}
	},
	{
		"selector": "//ClassMethod[@kind=='get']",
		"version": "2015",
		"en": {
			"name": "ClassMethod-get"
		}
	},
	{
		"selector": "//ClassMethod[@kind=='method']",
		"version": "2015",
		"en": {
			"name": "ClassMethod-method"
		}
	},
	{
		"selector": "//ClassMethod[@kind=='set']",
		"version": "2015",
		"en": {
			"name": "ClassMethod-set"
		}
	},
	{
		"selector": "//ClassMethod[@kind=='set']",
		"version": "2015",
		"en": {
			"name": "ClassMethod"
		}
	},
	{
		"selector": "//ClassProperty",
		"version": "proposal",
		"en": {
			"name": "ClassProperty"
		}
	},
	{
		"selector": "//ConditionalExpression",
		"version": "3",
		"en": {
			"name": "ConditionalExpression"
		}
	},
	{
		"selector": "//ContinueStatement",
		"version": "3",
		"en": {
			"name": "ContinueStatement"
		}
	},
	{
		"selector": "//DebuggerStatement",
		"version": "5",
		"en": {
			"name": "DebuggerStatement"
		}
	},
	{
		"selector": "//Decorator",
		"version": "proposal",
		"en": {
			"name": "Decorator"
		}
	},
	{
		"selector": "//Directive",
		"version": "5",
		"en": {
			"name": "Directive"
		}
	},
	{
		"selector": "//DirectiveLiteral",
		"version": "5",
		"en": {
			"name": "DirectiveLiteral"
		}
	},
	{
		"selector": "//DoWhileStatement",
		"version": "3",
		"en": {
			"name": "DoWhileStatement"
		}
	},
	{
		"selector": "//EmptyStatement",
		"version": "3",
		"en": {
			"name": "EmptyStatement"
		}
	},
	{
		"selector": "//ExportAllDeclaration",
		"version": "2015",
		"en": {
			"name": "ExportAllDeclaration"
		}
	},
	{
		"selector": "//ExportDefaultDeclaration",
		"version": "2015",
		"en": {
			"name": "ExportDefaultDeclaration"
		}
	},
	{
		"selector": "//ExportNamedDeclaration",
		"version": "2015",
		"en": {
			"name": "ExportNamedDeclaration"
		}
	},
	{
		"selector": "//ExportSpecifier",
		"version": "2015",
		"en": {
			"name": "ExportSpecifier"
		}
	},
	{
		"selector": "//ExpressionStatement",
		"trivial": true,
		"version": "3",
		"en": {
			"name": "ExpressionStatement"
		}
	},
	{
		"selector": "//ForInStatement",
		"version": "3",
		"en": {
			"name": "ForInStatement"
		}
	},
	{
		"selector": "//ForOfStatement",
		"version": "2015",
		"en": {
			"name": "ForOfStatement"
		}
	},
	{
		"selector": "//ForStatement",
		"version": "3",
		"en": {
			"name": "ForStatement"
		}
	},
	{
		"selector": "//FunctionDeclaration[@async==true]",
		"version": "proposal",
		"en": {
			"name": "async FunctionDeclaration"
		}
	},
	{
		"selector": "//FunctionDeclaration",
		"version": "3",
		"en": {
			"name": "FunctionDeclaration"
		}
	},
	{
		"selector": "//FunctionExpression",
		"version": "3",
		"en": {
			"name": "FunctionExpression"
		}
	},
	{
		"selector": "//Identifier",
		"version": "3",
		"en": {
			"name": "Identifier",
			"link": "https://developer.mozilla.org/docs/Glossary/identifier"
		}
	},
	{
		"selector": "//IfStatement",
		"version": "3",
		"en": {
			"name": "IfStatement"
		}
	},
	{
		"selector": "//ImportDeclaration",
		"version": "2015",
		"en": {
			"name": "ImportDeclaration"
		}
	},
	{
		"selector": "//ImportDefaultSpecifier",
		"version": "2015",
		"en": {
			"name": "ImportDefaultSpecifier"
		}
	},
	{
		"selector": "//ImportNamespaceSpecifier",
		"version": "2015",
		"en": {
			"name": "ImportNamespaceSpecifier"
		}
	},
	{
		"selector": "//ImportSpecifier",
		"version": "2015",
		"en": {
			"name": "ImportSpecifier"
		}
	},
	{
		"selector": "//LabeledStatement",
		"version": "3",
		"en": {
			"name": "LabeledStatement"
		}
	},
	{
		"selector": "//LogicalExpression",
		"version": "3",
		"en": {
			"name": "LogicalExpression"
		}
	},
	{
		"selector": "//MemberExpression",
		"version": "3",
		"en": {
			"name": "MemberExpression"
		}
	},
	{
		"selector": "//MetaProperty",
		"version": "2015",
		"en": {
			"name": "MetaProperty"
		}
	},
	{
		"selector": "//NewExpression",
		"version": "3",
		"en": {
			"name": "NewExpression"
		}
	},
	{
		"selector": "//NullLiteral",
		"version": "3",
		"en": {
			"name": "NullLiteral"
		}
	},
	{
		"selector": "//NumericLiteral",
		"version": "3",
		"en": {
			"name": "NumericLiteral"
		}
	},
	{
		"selector": "//ObjectExpression",
		"version": "3",
		"en": {
			"name": "ObjectExpression"
		}
	},
	{
		"selector": "//ObjectMethod[@kind=='get']",
		"version": "5",
		"en": {
			"name": "ObjectMethod-get"
		}
	},
	{
		"selector": "//ObjectMethod[@kind=='method']",
		"version": "2015",
		"en": {
			"name": "ObjectMethod-method"
		}
	},
	{
		"selector": "//ObjectMethod[@kind=='set']",
		"version": "5",
		"en": {
			"name": "ObjectMethod-set"
		}
	},
	{
		"selector": "//ObjectMethod[@kind=='method']",
		"version": "2015",
		"en": {
			"name": "ObjectMethod"
		}
	},
	{
		"selector": "//ObjectPattern",
		"version": "2015",
		"en": {
			"name": "ObjectPattern"
		}
	},
	{
		"selector": "//ObjectProperty[@computed==true]",
		"version": "2015",
		"en": {
			"name": "ComputedPropertyName"
		}
	},
	{
		"selector": "//ObjectProperty",
		"version": "3",
		"en": {
			"name": "ObjectProperty"
		}
	},
	{
		"selector": "//Program[@sourceType=='module']",
		"trivial": true,
		"version": "2015",
		"en": {
			"name": "Program-module"
		}
	},
	{
		"selector": "//Program[@sourceType=='script']",
		"trivial": true,
		"version": "2015",
		"en": {
			"name": "Program-script"
		}
	},
	{
		"selector": "//Program",
		"trivial": true,
		"version": "2015",
		"en": {
			"name": "Program"
		}
	},
	{
		"selector": "//RegExpLiteral",
		"version": "3",
		"en": {
			"name": "RegExpLiteral"
		}
	},
	{
		"selector": "//RestElement",
		"version": "2015",
		"en": {
			"name": "RestElement"
		}
	},
	{
		"selector": "//RestProperty",
		"version": "2015",
		"en": {
			"name": "RestProperty"
		}
	},
	{
		"selector": "//ReturnStatement",
		"version": "3",
		"en": {
			"name": "ReturnStatement"
		}
	},
	{
		"selector": "//SequenceExpression",
		"version": "3",
		"en": {
			"name": "SequenceExpression"
		}
	},
	{
		"selector": "//SpreadElement",
		"version": "2015",
		"en": {
			"name": "SpreadElement"
		}
	},
	{
		"selector": "//SpreadProperty",
		"version": "proposal",
		"en": {
			"name": "SpreadProperty"
		}
	},
	{
		"selector": "//StringLiteral",
		"version": "3",
		"en": {
			"name": "StringLiteral"
		}
	},
	{
		"selector": "//Super",
		"version": "2015",
		"en": {
			"name": "Super"
		}
	},
	{
		"selector": "//SwitchCase",
		"version": "3",
		"en": {
			"name": "SwitchCase"
		}
	},
	{
		"selector": "//SwitchStatement",
		"version": "3",
		"en": {
			"name": "SwitchStatement"
		}
	},
	{
		"selector": "//TaggedTemplateExpression",
		"version": "2015",
		"en": {
			"name": "TaggedTemplateExpression"
		}
	},
	{
		"selector": "//TemplateElement",
		"version": "2015",
		"en": {
			"name": "TemplateElement"
		}
	},
	{
		"selector": "//TemplateLiteral",
		"version": "2015",
		"en": {
			"name": "TemplateLiteral"
		}
	},
	{
		"selector": "//ThisExpression",
		"version": "3",
		"en": {
			"name": "ThisExpression"
		}
	},
	{
		"selector": "//ThrowStatement",
		"version": "3",
		"en": {
			"name": "ThrowStatement"
		}
	},
	{
		"selector": "//TryStatement",
		"version": "3",
		"en": {
			"name": "TryStatement"
		}
	},
	{
		"selector": "//UnaryExpression",
		"version": "3",
		"en": {
			"name": "UnaryExpression"
		}
	},
	{
		"selector": "//UpdateExpression",
		"version": "3",
		"en": {
			"name": "UpdateExpression"
		}
	},
	{
		"selector": "//VariableDeclaration[@kind=='const']",
		"version": "2015",
		"en": {
			"name": "VariableDeclaration const"
		}
	},
	{
		"selector": "//VariableDeclaration[@kind=='let']",
		"version": "2015",
		"en": {
			"name": "VariableDeclaration let"
		}
	},
	{
		"selector": "//VariableDeclaration[@kind=='var']",
		"version": "3",
		"en": {
			"name": "VariableDeclaration-var"
		}
	},
	{
		"selector": "//VariableDeclaration[@kind=='const']",
		"version": "2015",
		"en": {
			"name": "VariableDeclaration"
		}
	},
	{
		"selector": "//VariableDeclarator",
		"version": "3",
		"en": {
			"name": "VariableDeclarator"
		}
	},
	{
		"selector": "//WhileStatement",
		"version": "3",
		"en": {
			"name": "WhileStatement"
		}
	},
	{
		"selector": "//WithStatement",
		"version": "3",
		"en": {
			"name": "WithStatement"
		}
	},
	{
		"selector": "//YieldExpression",
		"version": "2015",
		"en": {
			"name": "YieldExpression"
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/ecmascript-version-detector/data/index.json
// module id = 68
// module chunks = 0